import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {schemaMachineByPoint} from '../../../../../../../../util/validationLavanderia'
import {EquipmentByPointModel, SelectModel} from '../../../../../../model'
import {createAssignMachine, getEquipment} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../../../components/UI/Select'
import {ShowSnackBar} from '../../../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  getAssignMachineList: () => void
  setIdPermissionList: () => void
  idPermission?: ''
  detailpermission?: EquipmentByPointModel
}

const ModalAddMachine: FC<Props> = ({
  show,
  setShow,
  setIdPermissionList,
  getAssignMachineList,
  idPermission,
  detailpermission,
}) => {
  const {currentTabItem} = useLavanderia()
  const [typeFurniture, setTypeFurniture] = useState<SelectModel[] | any>([])
  const {
    control,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm<EquipmentByPointModel>({
    resolver: yupResolver(schemaMachineByPoint),
  })

  const getEquipmentList = async () => {
    try {
      const response = await getEquipment({}, 1)
      const data = response.data.data
      const mappedMaster = data.map((master) => ({
        value: master.id,
        label: master.nombre,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  useEffect(() => {
    if (idPermission) {
      // setValue('vistaPermisoId', detailpermission?.vistaPermisoId)
      // setValue('vistaPermisoOpcionId', detailpermission?.vistaPermisoOpcionId)
      // getPermissionByOptionList(detailpermission?.vistaPermisoId)
    }
  }, [idPermission])

  useEffect(() => {
    getEquipmentList()
  }, [])

  const handleClose = () => {
    setShow(false)
    reset()
    setIdPermissionList()
  }

  const onSubmit = async (data: EquipmentByPointModel) => {
    try {
      let obj = {
        puntoId: currentTabItem.idToEdit,
        machines: [data.codigo],
      }

      const {data: res} = await createAssignMachine(obj)
      if (!res.error) {
        ShowSnackBar('Se actualizó con exito')
        handleClose()
        getAssignMachineList()
        //mostrar snackbar
      } else {
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {}
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          {<h5 className='modal-title'>Asignar Maquinaria</h5>}

          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='row'>
              <div className='mb-2 col-12'>
                <label className='required'>Maquinarias</label>
                <Select control={control} name='codigo' data={typeFurniture} errors={errors} />
              </div>
            </div>

            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalAddMachine}
